import { createContext, useContext, RefObject } from 'react'
import { noop } from '@manychat/manyui'

import {
  GoalEditorMode,
  SubmitRef,
} from 'apps/aiAutomation/components/EngagementGoalEditor/lib/types'
import { EngagementGoal, GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

interface GoalEditorContextProps<Goal extends EngagementGoal | null = EngagementGoal | null> {
  mode: GoalEditorMode
  goalId: string
  goal: Goal
  editorRef: RefObject<SubmitRef<EngagementGoal>> | null
  save: (goal: EngagementGoal, saveAndPublish?: boolean) => Promise<void> | void
  changeMode: (mode: GoalEditorMode) => void
}

export const GoalEditorContext = createContext<GoalEditorContextProps>({
  mode: GoalEditorMode.CREATE,
  goalId: '',
  goal: null,
  editorRef: null,
  save: noop,
  changeMode: noop,
})

export const useGoalEditorContext = <Type extends GoalType>(goalType: Type) => {
  const context = useContext(GoalEditorContext)

  if (!context) {
    throw new Error('GoalEditorContext is not provided')
  }

  if (context.goal && context.goal.type !== goalType) {
    throw new Error(`Requested ${goalType} but context stores ${context.goal.type}`)
  }

  return context as GoalEditorContextProps<Extract<EngagementGoal, { type: Type }>>
}
